//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/PDM.js";
import "../no/ScCollector.js";
let d=[[[0,"ExportFormat",1,0],[0,"SectionBodies",0,"ScCollector",0],[0,"StructureXMLFile",1,0],[0,"Type",1,0]],[[["partOperationBuilder"],"SetPartOperationBuilder",{},1,0],[["structurePartFilenames"],"SetStructureParts",{},1,0]],[]];
SPLM.Features.ShipDesign.ExportStructureXMLBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ExportStructureXMLBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ExportStructureXMLBuilder.Types = Object.freeze({
    "Section" : "Section", "Structure" : "Structure"});

SPLM.Features.ShipDesign.ExportStructureXMLBuilder.ExportFormats = Object.freeze({
    "ShipPLMXML" : "ShipPLMXML", "Dnvglocxxml" : "Dnvglocxxml"});

export default SPLM;